<template>
    <el-dialog
    :title="titleTrans"
    :visible.sync="centerDialogVisible"
    @close="cancel"
    width="70%"
  >

    <el-form ref="userCenter" :model="userCenter" label-width="120px" :rules="rules">
      <!-- 基本信息 -->
      <el-row>
        <el-col :span="2">
          <span class="header">基本信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="员工姓名" prop="name">
            <el-input v-model="userCenter.name" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态">
            <el-radio-group v-model="userCenter.isEnable">
              <el-radio :label="1" style="margin-right:40px">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="员工工号" prop="code">
            <el-input v-model="userCenter.code" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="手机号码" prop="telephone">
            <el-input v-model="userCenter.telephone" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="userCenter.sex" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in sexList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="userCenter.birthday"
              type="date"
              placeholder="选择出生日期"
              :picker-options="pickerOptionsTime"
            />

          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="民族" prop="nation">
            <el-select v-model="userCenter.nation" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in nationList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号码" prop="card">
            <el-input v-model="userCenter.card" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="婚姻状态" prop="marriageStatus">
            <el-select v-model="userCenter.marriageStatus" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in marryList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="个人邮箱" prop="email">
            <el-input v-model="userCenter.email" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="户籍地址" style="float:left" prop="censusProvince">
            <el-select
              v-model="userCenter.censusProvince"
              placeholder="请选择"
              @change="changeCensusProvince"
            >
              <el-option
                v-for="provinceItem in provinceList"
                :key="provinceItem.region_code"
                :label="provinceItem.region_name"
                :value="provinceItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px" class="ml4 mr4" label prop="censusCity" style="float:left">
            <el-select
              v-model="userCenter.censusCity"
              placeholder="请选择"
              @change="changeCensusCity"
            >
              <el-option
                v-for="cityItem in cityList"
                :key="cityItem.region_code"
                :label="cityItem.region_name"
                :value="cityItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px" class="ml4 mr4" label prop="censusArea" style="float:left">
            <el-select
              v-model="userCenter.censusArea"
              placeholder="请选择"
              @change="changeCensusCounty"
            >
              <el-option
                v-for="cityItem in areaList"
                :key="cityItem.region_code"
                :label="cityItem.region_name"
                :value="cityItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="float:left;margin-left:-19px" prop="censusAddress">
            <el-input v-model="userCenter.censusAddress" style="left:-96px;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="紧急联系人姓名" prop="crashName">
            <el-input v-model="userCenter.crashName" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="现居住地" style="float:left" prop="liveProvince">
            <el-select
              v-model="userCenter.liveProvince"
              placeholder="请选择"

              @change="changeLiveProvince"
            >
              <el-option
                v-for="provinceItem in provinceList"
                :key="provinceItem.region_code"
                :label="provinceItem.region_name"
                :value="provinceItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px" class="ml4 mr4" label prop="liveCity" style="float:left">
            <el-select
              v-model="userCenter.liveCity"
              placeholder="请选择"

              @change="changeLiveCity"
            >
              <el-option
                v-for="cityItem in cityList"
                :key="cityItem.region_code"
                :label="cityItem.region_name"
                :value="cityItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px" class="ml4 mr4" label prop="liveArea" style="float:left">
            <el-select
              v-model="userCenter.liveArea"
              placeholder="请选择"

              @change="changeLiveCounty"
            >
              <el-option
                v-for="cityItem in areaList"
                :key="cityItem.region_code"
                :label="cityItem.region_name"
                :value="cityItem.region_name"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="float:left;margin-left:-19px" prop="liveAddress">
            <el-input v-model="userCenter.liveAddress" style="left:-96px;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="紧急联系人电话" prop="crashPhone">
            <el-input v-model="userCenter.crashPhone" />
          </el-form-item>
        </el-col>

      </el-row>

      <!-- 院校信息 -->
      <el-row>
        <el-col :span="2">
          <span class="header">院校信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="graduatedSchool">
            <el-input v-model="userCenter.graduatedSchool" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业" prop="specialty">
            <el-input v-model="userCenter.specialty" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学历" prop="education">

            <el-select
              v-model="userCenter.education"
              placeholder="请选择"
              style="width:100%"
            >
              <el-option
                v-for="item in educationList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="graduatedTime">
            <el-date-picker
              v-model="userCenter.graduatedTime"
              type="date"
              placeholder="选择毕业时间"
              :picker-options="pickerOptionsTime"
            />
          </el-form-item>
        </el-col>

      </el-row>

      <!-- 收件信息 -->
      <el-row>
        <el-col :span="2">
          <span class="header">岗位信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="部门" prop="officeId">
            <el-select
              v-model="userCenter.officeId"
              filterable

              placeholder="请选择部门"
              style="width:100%"
            >
              <el-option
                v-for="item in departList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职务" prop="position">
            <el-input v-model="userCenter.position" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职等" prop="grade">
            <el-input v-model="userCenter.grade" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 角色管理 -->
      <el-row>
        <el-col :span="2">
          <span class="header">角色信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="关联角色">
            <el-tag
              v-for="tag in roleList"
              :key="tag.id"
              v-model="roleIds"
              :value="tag.id"
              :class="isActive.indexOf(tag.id)!==-1?'Active':''"
              @click="changeActive(tag.name,tag.id)"
            >
              {{ tag.name }}
            </el-tag>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
  <span
  slot="footer"
  class="dialog-footer"
>
<el-button plain style="margin-right:8px" @click="cancel">取消</el-button>
<el-button type="primary" @click="sure('userCenter')">确认</el-button>
</span>
</el-dialog>
</template>
<script>
import { getLocalDictionary, userInfo, update, roleList, getDepartList,validatePhone } from '@/api/system'
import { nationList } from '@/api/nation'
import {
  lengthFifty,
  lengthTen,
  validateEmail,
  validateTwenty,
  validateNumber,
  validateQq,
  validateBankCode,
  lengthThirty,
  lengthFifteen,
  validateTenNumber,
  validateCard,
  validateStrPhone

} from '@/api/validate'
import data from '@/api/getArea'
export default {
  props: ['userId', 'isEdit'],
  data() {
    return {
      sexList: [{ code: 1, name: '男' }, { code: 2, name: '女' }],
      marryList: [
        { id: 1, name: '未婚' },
        { id: 2, name: '已婚' },
        { id: 3, name: '离异' },
        { id: 4, name: '丧偶' }
      ],
      educationList: [
        { id: 1, name: '小学' },
        { id: 2, name: '初中' },
        { id: 3, name: '高中' },
        { id: 4, name: '本科' },
        { id: 5, name: '硕士' },
        { id: 6, name: '博士' },
        { id: 7, name: '博士后' }
      ],
      roleList: [],
      userCenter: {
        name: '',
        code: '',
        telephone: '',
        sex: '',
        birthday: '',
        nation: '',
        card: '',
        marriageStatus: '',
        email: '',
        censusProvince: '',
        censusCity: '',
        censusArea: '',
        censusAddress: '',
        liveProvince: '',
        liveCity: '',
        liveArea: '',
        liveAddress: '',
        crashName: '',
        crashPhone: '',
        graduatedSchool: '',
        specialty: '',
        education: '',
        graduatedTime: '',
        officeId: '',
        position: '',
        grade: '',
        isEnable: 1,
        id: ''

      },
      centerDialogVisible: true,
      roleIds: '',
      tradeList: [],
      userTypeList: [],
      rules: {
        name: [
          {
            required: true,
            validator: validateTwenty,
            trigger: 'change'
          }
        ],
        code: [
          {
            required: true,
            validator: validateTenNumber,
            trigger: 'change'
          }
        ],
        telephone: [
          {
            required: true,
            validator: this.validateStrPhone,
            trigger: 'blur'
          }
        ],
        sex: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        birthday: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        nation: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        card: [
          {
            required: true,
            validator: validateCard,
            trigger: 'change'
          }
        ],
        marriageStatus: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'change'
          }
        ],
        censusProvince: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        censusCity: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        censusArea: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        censusAddress: [
          {
            required: true,
            validator: lengthFifty,
            trigger: 'blur'
          }
        ],
        liveProvince: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        liveCity: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        liveArea: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        liveAddress: [
          {
            required: true,
            validator: lengthFifty,
            trigger: 'blur'
          }
        ],
        crashName: [
          {
            required: true,
            validator: validateTwenty,
            trigger: 'change'
          }
        ],
        crashPhone: [
          {
            required: true,
            validator: lengthFifteen,
            trigger: 'change'
          }
        ],
        graduatedSchool: [
          {
            required: true,
            validator: lengthFifty,
            trigger: 'change'
          }
        ],
        specialty: [
          {
            required: true,
            validator: lengthThirty,
            trigger: 'change'
          }
        ],
        education: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        graduatedTime: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'change'
          }
        ],
        officeId: [
          {
            required: true,
            message: '必选不能为空',
            trigger: 'blur'
          }
        ],
        position: [
          {
            required: true,
            validator: validateTwenty,
            trigger: 'change'
          }
        ],
        grade: [
          {
            required: true,
            validator: validateTwenty,
            trigger: 'change'
          }
        ]
        // roleIds: [
        //   {
        //     required: true,
        //     message: "必选不能为空",
        //     trigger: "change"
        //   }
        // ]

      },
      provinceList: [],
      cityList: [],
      areaList: [],
      nationList: [],
      isActive: '',
      departList: [],
      arr:[],
      flag:false,
      pickerOptionsTime: {
          disabledDate(time) {
            return time.getTime() >new Date(new Date().toLocaleDateString()).getTime()
          }
        },
    }
  },
  computed: {
    titleTrans() {
      let result = '添加员工'
      if (this.isEdit) {
        result = '编辑员工'
      }
      return result
    }
  },
  mounted() {
    
    if (this.isEdit) {
      this.fetchData()
    }
  
    this.getRoleList()
    getDepartList().then(res => {
      if (res && res.code == 0) {
        this.departList = res.data
      }
    })
    this.provinceList = data.data.items
    this.nationList = nationList().data
  },
  methods: {
    getRoleList() {
      roleList({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        if (res && res.code == 0) {
          this.roleList = res.data.items
        }
      })
    },
    changeCensusProvince() {
      this.userCenter.censusCity = null
      this.userCenter.censusArea = null
      this.provinceList.forEach(item => {
        if (item.region_name === this.userCenter.censusProvince) {
          this.cityList = item.children
        }
      })
    },
    changeLiveProvince() {
      this.userCenter.liveCity = null
      this.userCenter.liveArea = null
      this.provinceList.forEach(item => {
        if (item.region_name === this.userCenter.liveProvince) {
          this.cityList = item.children
        }
      })
    },
    changeCensusCity() {
      this.userCenter.censusArea = null
      this.cityList.forEach(item => {
        if (item.region_name === this.userCenter.censusCity) {
          this.areaList = item.children
        }
      })
    },
    changeLiveCity() {
      this.userCenter.liveArea = null
      this.cityList.forEach(item => {
        if (item.region_name === this.userCenter.liveCity) {
          this.areaList = item.children
        }
      })
    },
    changeCensusCounty() {},
    changeLiveCounty() {},
    fetchData() {
      userInfo({
        id: this.userId
      }).then(res => {
        if (res && res.code == 0) {
          this.userCenter.name = res.data.userCenter.name
          this.userCenter.code = res.data.userCenter.code
          this.userCenter.telephone = res.data.userCenter.telephone
          this.userCenter.sex = res.data.userCenter.sex
          this.userCenter.birthday = res.data.userCenter.birthday
          this.userCenter.nation = res.data.userCenter.nation
          this.userCenter.card = res.data.userCenter.card
          this.userCenter.marriageStatus = res.data.userCenter.marriageStatus
          this.userCenter.email = res.data.userCenter.email
          this.userCenter.censusProvince = res.data.userCenter.censusProvince
          this.userCenter.censusCity = res.data.userCenter.censusCity
          this.userCenter.censusArea = res.data.userCenter.censusArea
          this.userCenter.censusAddress = res.data.userCenter.censusAddress
          this.userCenter.liveProvince = res.data.userCenter.liveProvince
          this.userCenter.liveCity = res.data.userCenter.liveCity
          this.userCenter.liveArea = res.data.userCenter.liveArea
          this.userCenter.liveAddress = res.data.userCenter.liveAddress
          this.userCenter.crashName = res.data.userCenter.crashName
          this.userCenter.crashPhone = res.data.userCenter.crashPhone
          this.userCenter.graduatedSchool = res.data.userCenter.graduatedSchool
          this.userCenter.specialty = res.data.userCenter.specialty
          this.userCenter.education = res.data.userCenter.education
          this.userCenter.graduatedTime = res.data.userCenter.graduatedTime
          this.userCenter.officeId = res.data.userCenter.officeId
          this.userCenter.position = res.data.userCenter.position
          this.userCenter.grade = res.data.userCenter.grade
          this.userCenter.isEnable=res.data.userCenter.isEnable
          this.roleIds = res.data.roleIds
          this.userCenter.id = res.data.userCenter.id
          this.isActive = res.data.roleIds
          if(res.data.roleIds.length>0){
            const arr1=res.data.roleIds.split(",")
          for(var i=0;i<arr1.length;i++){
            this.arr.push(arr1[i])
          }
          }
         
           
        }
      })
    },
    cancel() {
      this.$emit('returnResult')
    },
    sure(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updateUserInfo()
        }
      })
    },
    updateUserInfo() {
      this.userCenter.birthday = this.dateTrans(this.userCenter.birthday)
      this.userCenter.graduatedTime = this.dateTrans(this.userCenter.graduatedTime)

      update({
        userCenter: this.userCenter,
        roleIds: this.roleIds
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('returnResult')
        } 
      })
    },
    changeActive(data, id) {
       const ids=id+""
       const str=this.arr.toString()
       if(str.indexOf(ids)==-1){
         this.arr.push(ids)
       }else if(str.indexOf(ids)!=-1){
         for(var i=0;i<this.arr.length;i++){
           if(this.arr[i]==ids){
             this.arr.splice(i,1)
           }
         }
       }
       this.roleIds=this.arr.toString()
      this.isActive = this.roleIds
      // console.log(this.roleIds)
    },
    validateStrPhone(rule, value, callback){
      if (value) {
        validatePhone({ 
          telephone: this.userCenter.telephone,
          userId:this.userId
          }).then(res => {
          if (res && res.code == 0) {
            this.flag = res.data
            const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (value == '' || value == null || value == undefined) {
              callback(new Error('手机号不能为空'))
            } else if (value && value.length && !myreg.test(value)) {
              callback(new Error('手机号格式不对'))
            } else if (this.flag) {
              callback(new Error('手机号不可以重复'))
            } else {
              callback()
            }
          }
        })
      }else{
        callback(new Error('手机号不能为空'))
      }
    },
    dateTrans(val) {
      console.log(val)
      var date = new Date(val)
      const year = date.getFullYear()
      var month
      if ((date.getMonth() + 1) < 10) {
        month = '0' + (date.getMonth() + 1)
      } else {
        month = date.getMonth()
      }
      var day
      if (date.getDate() < 10) {
        day = '0' + date.getDate()
      } else {
        day = date.getDate()
      }
      console.log(year + '-' + month + '-' + day)
      return year + '-' + month + '-' + day
    }

  }
}
</script>
<style lang="scss" scoped>
.el-col-22 {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.header {
  position: relative;
  top: -8px;
  right: -12px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
select {
  outline: none;
}
.el-select{
  width:85px;
}
/deep/.distpicker-address-wrapper select {
  font-size: 14px;
  height: 30px;
  padding: 5px 12px;
  border-radius: 0px;
  outline: none;
}
/deep/.distpicker-address-wrapper select:focus {
  border: 1px solid #ffa940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select:active {
  border: 1px solid #ffa940 !important;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:hover {
  background: #ffa940 !important;
  background-color: #ffa940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select option {
  border: 1px solid #ffa940;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:focus,
.distpicker-address-wrapper select option:active {
  border: 1px solid #ffa940;
  outline: none;
}
.el-col-24 {
  border-top: 1px solid #e8e8e8;
  padding-top: 8px;
  text-align: right;
}
.el-tag {
   margin-right: 8px;
  padding: 0px 8px;
  height:22px;
  line-height:22px;
  color: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(0, 0, 0, 0.05);

  background-color: rgba(0, 0, 0, 0.05);

  border-radius: 20px;
}
.Active {
  background-color: rgba(255, 169, 64, 0.05);
  border: 1px solid #ffa940;
  color: #ffa940;
}
.el-date-editor.el-input{
  width:100%;
}
/deep/.el-dialog__header {
    padding:18px 0px 18px 24px;
    font-size: 16px;
  .el-dialog__title {
    font-size: 16px;
  }
  .el-icon-close {
    line-height: 36px;
  }
}
/deep/.el-dialog__body {
  height: 60vh;
  overflow-y: scroll;
  position: relative;


}
/deep/.el-dialog__body {
  padding-top: 32px;
}
/deep/.el-dialog__footer{
  border-top:1px solid rgba(0,0,0,0.09);
  padding:8px 16px 8px 0px;
}
</style>
